import { Modal, Router } from '@autoprog/core-client';

import Utils from '@libs/utils/Utils';

export type ModalOptions = {
	modalID?: string,
	data?: { [key: string]: any },
	tpl?: string | ((data: object) => string),
	template?: string | ((data: object) => string),
	keyboard?: boolean
	backdrop?: boolean | 'static'
};

class ModalApps extends Modal {
	protected ignoreChangeRoute = false;

	constructor(options: ModalOptions) {
		super(options);

		Router.getInstance().on('route.change', (route: any, params: any, query: any, event: any) => {
			return new Promise<void>((resolve, reject) => {
				//@ts-ignore
				if (Modal.modals[Modal.modals.length - 1].modalID === this.modalID && !this.ignoreChangeRoute) {
					event.stopPropagation();
					reject(new Error('close modal'));
					this.reject();
				} else {
					resolve();
				}
			});
		}, {
			signal: this.abortSignal
		});

		this.on('opened', () => {
			const N_body = this.element.querySelector<HTMLElement>('.modal-body');

			N_body!.addEventListener('scroll', () => {
				const isScrollBottom = N_body!.scrollHeight - N_body!.scrollTop - N_body!.clientHeight < 1;
				const isScrollTop = N_body!.scrollTop < 1;

				this.element?.classList.add('modal-scroll-bottom');
				this.element?.classList.add('modal-scroll-top');

				if (isScrollBottom) {
					this.element?.classList.remove('modal-scroll-bottom');
				}

				if (isScrollTop) {
					this.element?.classList.remove('modal-scroll-top');
				}
			});

			this.element?.classList.add('modal-scroll-bottom');

			if (N_body!.scrollHeight > N_body!.offsetHeight) {
				this.element?.classList.add('modal-scroll-bottom');
			}

			Utils.removeTooltip();
		});
	}
}

export default ModalApps;
